exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".template-block {\n  position: relative;\n}\n.template-select-header {\n  margin-bottom: 40px;\n  margin-left: 20px;\n}\n.template-select-header mat-select {\n  margin-top: 10px;\n  width: 300px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/hq/cards/view-cards/grouped-by-size/size.component.css
// module id = ../../../../../src/app/hq/cards/view-cards/grouped-by-size/size.component.css
// module chunks = main